import React, { Dispatch, SetStateAction } from "react";
import RadioBtn from "../../../../../Button/RadioBtn";
import Flex from "../../../../../DefaultStyles/Flex";
import { FaqDetailLabel, FaqDetailRow } from "../ManageFaqDetailInput";

interface NoticeTopInputProps {
  check: {
    top: boolean;
    normal: boolean;
  };
  setCheck: Dispatch<
    SetStateAction<{
      public: boolean;
      private: boolean;
      top: boolean;
      normal: boolean;
      hasService: boolean;
      noService: boolean;
    }>
  >;
  isEditMode: boolean;
}

export default function NoticeTopInput({
  check,
  setCheck,
  isEditMode,
}: NoticeTopInputProps) {
  return (
    <FaqDetailRow>
      <FaqDetailLabel>상단 고정</FaqDetailLabel>

      <Flex gapSize={55}>
        <RadioBtn
          label="해당 없음"
          noTooltip={true}
          check={check?.normal}
          clickEvent={() =>
            setCheck((prev) => ({
              ...prev,
              normal: !prev.normal,
              top: false,
            }))
          }
          disabled={!isEditMode}
        />

        <RadioBtn
          label="상단 고정"
          noTooltip={true}
          check={check?.top}
          clickEvent={() =>
            setCheck((prev) => ({
              ...prev,
              normal: false,
              top: !prev.top,
            }))
          }
          disabled={!isEditMode}
        />
      </Flex>
    </FaqDetailRow>
  );
}
